import styled from 'styled-components';
import colors from '../../includes/colors';

export const FooterBox = styled.footer`
  flex-shrink: 0;
  z-index: 5;
  background-color: ${colors.darkBlue};
  border-bottom: 1px solid #0076ce;
`;

export const UnorderedList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const NavItem = styled.li`
  color: ${colors.white};
  font-size: 0.875rem;
  white-space: nowrap;
  float: left;

  .nav-link {
    color: ${colors.white};
    white-space: nowrap;
    font-size: 0.875rem;
    display: block !important;
  }

  @media (max-width: 425px) {
    width: 100%;
    border-top: solid 1px ${colors.white};
    &:first-child {
      border-top: none;
    }
    &:last-child {
      border-top: solid 1px ${colors.white} !important;
    }
  }

  @media (max-width: 1024px) {
    font-size: 0.75rem;

    .nav-link {
      white-space: nowrap;
      font-size: 0.75rem;
    }
  }
`;

export const Nav = styled.div`
  @media (max-width: 767px) {
    width: 100%;
  }

  @media (min-width: 768px) {
    display: flex;
    align-items: center;

    &.language-selector-container {
      flex: 0 1 auto;

      li {
        width: max-content;
      }
    }
  }
`;
